import { render } from "./CheckRegister.vue?vue&type=template&id=d22f9070&scoped=true"
import script from "./CheckRegister.vue?vue&type=script&lang=js"
export * from "./CheckRegister.vue?vue&type=script&lang=js"

import "./CheckRegister.vue?vue&type=style&index=0&id=d22f9070&scoped=true&lang=css"
import "./CheckRegister.vue?vue&type=style&index=1&id=d22f9070&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22f9070"]])

export default __exports__